export default __webpack_public_path__ + "static/media/Favicon-Genesis.b43f9cf1.svg";